import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuBurger = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 14,
	viewBox: "0 0 18 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0 0.25H18V2.5H0V0.25ZM0 5.875H18V8.125H0V5.875ZM0 11.5H18V13.75H0V11.5Z",
		fill: "#583F35"
	})]
});
const ForwardRef = forwardRef(SvgMenuBurger);
export { ForwardRef as ReactComponent };
